import { getBackgroundImage, formatDateTime } from "../../helpers";
export const buildPreLiveProps = (event, config) => {
    return {
        title: event.leagueName,
        team1Name: event.team1Name,
        team2Name: event.team2Name,
        startEventDate: formatDateTime(config, event.startEventDate),
        versus: config.dict.Versus,
        backgroundImage: getBackgroundImage(event, config.cmsConfig.backgroundImages)
    };
};
//# sourceMappingURL=buildPreLiveProps.js.map